import Axios from "axios";
import qs from 'qs'
import { useCommon } from '@/store/useCommon';
import pinia from '@/store'
import type { AxiosRequestConfig, AxiosResponse } from 'axios'

const epgInstance = Axios.create({
  baseURL: 'http://d28xfa7o1p887v.cloudfront.net',
  timeout: 60000,
})

// 请求拦截
epgInstance.interceptors.request.use((config: AxiosRequestConfig & DefaultObjectType) => {
  if (config?.type == 'upload') {
    config.headers['Content-Type'] = 'multipart/form-data'
  } else if (config?.type == 'json') {
    config.headers['Content-Type'] = 'application/json'
  }else {
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    config.data = qs.stringify(config.data, {
      arrayFormat: config.arrayFormat || 'indices',
      allowDots: true,
    })
  }

  //格式化data参数
  config.transformRequest = [function(data, headers) {
    return qs.parse(qs.stringify(data,{
      arrayFormat: config.arrayFormat || 'indices',
      allowDots: true,
    }))
  }]

  // 格式化params参数
  config.paramsSerializer = (params) => {
    return qs.stringify(params, { arrayFormat: 'repeat' })
  }
  
  const storeCommon = useCommon()
  // console.log('api', storeCommon.userData)
  // 添加token

  // const { token, userData } = storeCommon
  // if(token) config.headers['token'] = token
  // // console.log('cid',userData.cid[0])
  // if(userData.cid) config.headers['cid'] = userData.cid[0]
  return config
}, err => {
  console.error(err)
  return Promise.reject(err)
})


// 响应拦截
epgInstance.interceptors.response.use((result: AxiosResponse) => {
  return result
}, err => {
  console.error(err)
  return Promise.reject(err)
})

export default epgInstance